<template>
  <div id="app">

    <Head v-if="type=='pc'" />
    <MobileHead v-if="type=='mobile'" />
    <router-view />
  </div>
</template>
<script>
import Head from "./components/pc/Head"
import MobileHead from "./components/mobile/Head"
export default {
  components: {
    Head,
    MobileHead
  },
  data() {
    return {
      type: ""
    }
  },
  created() {
    const deviceW = document.body.clientWidth
    const name = this.$route.name
    if (deviceW <= 500) {
      this.type = "mobile"
      if (!/^mobile-/.test(name)) {
        this.$router.push("mobile-home")
      }
    } else {
      this.type = "pc"
    }
  },
  mounted() {
    const url = encodeURIComponent(location.href.split('#')[0])
    const api = `https://aomiapi.aomipay.com/service/wapWeixinSign.do?url=${url}`
    const jsApiList = ["onMenuShareTimeline", "onMenuShareAppMessage"]
    const cb = function() {
      wx.onMenuShareTimeline({
        title: `澳覓APP 暢想指尖生活`, // 分享标题
        link: `${location.href}`, // 分享链接
        imgUrl:
          "https://aomipay-pic.oss-cn-hongkong.aliyuncs.com/aomi-activity/aomiIcon.png", // 分享图标
        success: function() {},
        cancel: function() {}
      })
      wx.onMenuShareAppMessage({
        title: `澳覓APP 暢想指尖生活`, // 分享标题
        desc: `澳覓APP是澳門最大的生活服務平台`, // 分享描述
        link: `${location.href}`, // 分享链接
        imgUrl:
          "https://aomipay-pic.oss-cn-hongkong.aliyuncs.com/aomi-activity/aomiIcon.png", // 分享图标
        type: "",
        dataUrl: "",
        success: function() {},
        cancel: function() {}
      })
    }
    this.axios.get(api).then(data => {
      data = data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.detailMsg.appId, // 必填，公众号的唯一标识
        timestamp: data.detailMsg.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.detailMsg.nonceStr, // 必填，生成签名的随机串
        signature: data.detailMsg.signature, // 必填，签名，见附录1
        jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      wx.ready(cb)
    })
  }
}
</script>
<style lang="scss">
#app {
  font-family: "微軟雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
